import mutations from './codeStoreCrud.mutations'
import actions from './codeStoreCrud.actions'
import getters from './codeStoreCrud.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
